import { lazy } from 'react';
import { createBrowserRouter, Outlet } from 'react-router-dom';

import RootLayout from '../layout/RootLayout';
import AuthLayout from '../layout/AuthLayout';
import DashLayout from '../layout/DashLayout';
import SurgeonRoute from '../components/routes/SurgeonRoute';
import SurgeonLayout from '../layout/SurgeonLayout';

const HomeView = lazy(() => import('../pages/public/P01Home/HomeView'));
const SurgeonsView = lazy(() => import('../pages/public/P02Surgeons/SurgeonsView'));
const DetailsView = lazy(() => import('../pages/public/P02Surgeons/DetailsView'));
const AboutView = lazy(() => import('../pages/public/P03About/AboutView'));
const FaqView = lazy(() => import('../pages/public/P04Faq/FaqView'));
const HowItWorksView = lazy(() => import('../pages/public/P05How/HowItWorksView'));
const BlogView = lazy(() => import('../pages/public/P06Blog/BlogView'));
const BlogDetailView = lazy(() => import('../pages/public/P06Blog/BlogDetailView'));
const TermsView = lazy(() => import('../pages/public/P07Legal/TermsView'));
const PrivacyView = lazy(() => import('../pages/public/P07Legal/PrivacyView'));
const CookiePolicyView = lazy(() => import('../pages/public/P07Legal/CookiePolicyView'));
const UserDashboardPage = lazy(() => import('../pages/user/UserDashboardPage'));
const SurgeonProfilePage = lazy(() => import('../pages/surgeon/SurgeonProfilePage'));

// Auth views
const LoginView = lazy(() => import('../pages/auth/LoginView'));
const RegisterView = lazy(() => import('../pages/auth/RegisterView'));
const ResetPasswordView = lazy(() => import('../pages/auth/ResetPasswordView'));
const SetPasswordView = lazy(() => import('../pages/auth/SetPasswordView'));
const PricingView = lazy(() => import('../pages/auth/PricingView'));
const PricingSelect = lazy(() => import('../pages/auth/PricingSelect'));
const SurgeonCheckout = lazy(() => import('../pages/auth/SurgeonCheckout'));
const PaymentSuccess = lazy(() => import('../pages/auth/PaymentSuccess'));
const VerifyIdentityView = lazy(() => import('../pages/auth/VerifyIdentityView'));

// Dashboard views
const DashView = lazy(() => import('../pages/dash/dash01Home/DashView'));
const SergeonsView = lazy(() => import('../pages/dash/dash02Sergoens/SergoensView'));
const SurgeonDetails = lazy(() => import('../pages/dash/dash02Sergoens/SurgeonDetails'));
const DashPricingView = lazy(() => import('../pages/dash/dash03Pricing/PricingView'));
const SubscriptionView = lazy(() => import('../pages/dash/dash04Subscription/SubscriptionView'));
const RevenueView = lazy(() => import('../pages/dash/dash05Reveneu/RevenueView'));
const ReportsView = lazy(() => import('../pages/dash/dash06Reports/ReportsView'));
const PromoView = lazy(() => import('../pages/dash/dash07Promo/PromoView'));
const SettingsView = lazy(() => import('../pages/dash/dash08Settings/SettingsView'));
const SettingsCity = lazy(() => import('../pages/dash/dash08Settings/CitySetting'));
const UsersView = lazy(() => import('../pages/dash/dash09Users/UsersView'));

const NotFound = lazy(() => import('../pages/error/NotFound'));

const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: HomeView },
      { path: 'surgeons', Component: SurgeonsView },
      { path: 'surgeons/:id', Component: DetailsView },
      { path: 'about', Component: AboutView },
      { path: 'faq', Component: FaqView },
      { path: 'how-it-works', Component: HowItWorksView },
      { path: 'blog', Component: BlogView },
      { path: 'blog/:slug', Component: BlogDetailView },
      { path: 'terms', Component: TermsView },
      { path: 'privacy', Component: PrivacyView },
      { path: 'cookie-policy', Component: CookiePolicyView },
      { path: 'user', Component: UserDashboardPage },
      {
        path: 'surgeon',
        Component: SurgeonLayout,
        children: [
          { path: 'profile', Component: SurgeonProfilePage },
          { path: 'pricing', Component: PricingSelect },
          { path: 'checkout/:id', Component: SurgeonCheckout },
          { path: 'payment-success', Component: PaymentSuccess },
          { path: 'payment-failed', Component: SurgeonCheckout },
        ],
      },
      { path: '*', Component: NotFound },
    ],
  },
  {
    path: '/auth',
    Component: AuthLayout,
    children: [
      { path: 'login', Component: LoginView },
      { path: 'register', Component: RegisterView },
      { path: 'reset-password', Component: ResetPasswordView },
      { path: 'set-password', Component: SetPasswordView },
      { path: 'pricing', Component: PricingView },
      { path: 'verify-identity', Component: VerifyIdentityView },
    ],
  },
  {
    path: '/dash',
    Component: DashLayout,
    children: [
      { index: true, Component: DashView },
      { path: 'surgeons', Component: SergeonsView },
      { path: 'users', Component: UsersView },
      { path: 'surgeon-profiles/:id', Component: SurgeonDetails },
      { path: 'pricing', Component: DashPricingView },
      { path: 'subscriptions', Component: SubscriptionView },
      { path: 'revenue', Component: RevenueView },
      { path: 'reports', Component: ReportsView },
      { path: 'promo', Component: PromoView },
      { path: 'settings', Component: SettingsCity },
      { path: 'profile', Component: SettingsView },
    ],
  },
]);

export default router;
